export default __webpack_public_path__ + "static/media/20.18ac77ac.png";